export const serviceOptions = [
  { label: 'Consultoria Estratégica', value: 'consultoria-estrategica' },
  { label: 'Formação e Capacitação', value: 'formacao-e-capacitacao' },
  {
    label: 'Assessoria em Projetos e Eventos',
    value: 'assessoria-em-projetos-e-eventos',
  },
  { label: 'Advocacy e Pesquisa Aplicada', value: 'advocacy-e-pesquisa' },
]
